module.exports = __webpack_public_path__ + "static/media/NIFTY-BNB-APE.c02b4035.png";